var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('vs-chip',{staticClass:"chip-element",attrs:{"title":_vm.$t(("enums.civilCaseStatuses." + (_vm.status.key))),"color":_vm.status.color}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }